module.exports = __webpack_public_path__ + "static/img/decorate-2.b0d0e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/decorate-2.png
// module id = 3aPf
// module chunks = 65